import { useContext } from 'react';

import { PatientContext } from '../components/patient-management/PatientPage/PatientContext';

/**
 * Primarily used in PIS where the PatientProvider is not always guaranteed to be present.
 * If the context is not available, it returns safe defaults instead of throwing an error.
 */
export const useSafePatientPageContext = () => {
  const context = useContext(PatientContext);

  if (!context) {
    return { patient: null, actions: null };
  }

  return context;
};
